const computeSits = ({val, totalSits, availableBoats, availableSits}) => {
    const available_boats = val > 0 ? val : 1;
    const total_sits = totalSits / availableBoats * available_boats;
    const available_sits = availableSits - (totalSits - total_sits)

    return {available_boats, total_sits, available_sits}
}
export default computeSits